import { Controller } from "@hotwired/stimulus"

// Submit the form as soon as a control changes, so a selection persists without a
// separate Save click. Used by the campaign wizard's persona picker: ticking a
// persona saves the targeting immediately, giving "Draft with AI" a source.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
